<template>
  <div class="page-template">
<!--    <div class="page-title">{{ title }}</div>-->
    <search-form-template
      ref="salesStatistical"
      :searchOptions="searchOptions"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      :toolConfig="toolConfig"
    ></search-form-template>
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <!--<el-tab-pane label="销售统计" name="sales">-->
        <!--<table-template v-if="activeTab === 'sales'" ref="sales" :tableOptions="sales">-->
        <!--</table-template>-->
      <!--</el-tab-pane>-->
      <el-tab-pane label="畅销品排行" name="readySale">
        <table-template v-if="activeTab === 'readySale'" ref="readySale" :tableOptions="readySale"></table-template>
      </el-tab-pane>
      <el-tab-pane label="滞销品排行" name="unmarketable">
        <table-template v-if="activeTab === 'unmarketable'" ref="unmarketable" :tableOptions="unmarketable"></table-template>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="商品销售趋势记录分析" :visible.sync="analyseShow" width="700px" height="700px"
               :close-on-click-modal="false">
      <el-button @click="getHour">按小时统计</el-button>
      <el-button @click="getDay">按天统计</el-button>
      <echarts-template class="charts-trend" ref="goodsSaleTrendEcharts"
                        :picOption="goodsSaleTrendEcharts">
      </echarts-template>
    </el-dialog>
    <el-dialog title="商品销售会员记录" :visible.sync="listShow" width="1000px" height="2000px" :close-on-click-modal="false">
      <div class="headerButton">
        <el-button @click="salesExport">导出</el-button>&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked"
                                                                                     @change="memberChecked">合并相同会员
      </el-checkbox>
      </div>
      <table-template :tableOptions="listColumns" ref="goodsCode"></table-template>
    </el-dialog>
  </div>
</template>

<script>
  import api from "@/config/api";
  import pageTemplate from "@/components/template/pageTemplate";
  import userPower from "@/mixin/userPower";
  import tableTemplate from '@/components/template/tableTemplate';
  import echartsTemplate from "@/components/controls/echarts";
  import {goodsSaleTrendEcharts} from "@/page/home/options/saleReportEcharts"

  export default {
    mixins: [userPower],
    components: {pageTemplate, tableTemplate, echartsTemplate},
    data() {
      let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let defaultParam = {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
      return {
        activeTab: 'readySale',
        goodsName: '',
        param: defaultParam,
        goodsSaleTrendEcharts,
        isCombine: false,
        tableData: [],
        goodsId: '',
        memberMerge: '',
        checked: false,
        page: {
          current: 1,
          total: 0,
          pageSize: 10
        },
        listShow: false,
        analyseShow: false,
        //  dialogVisibility: false,
        searchOptions: {
          simple: [
            {label: '', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: "商品条码/名称"},
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              span: 6,
              data: [],
              isHasAll:true,
              url: api.store.store,
              change:this.storeChange,
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              span: 6,
              data: [],
              // url: api.archives.brand,
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              span: 6,
              data: [],
              // url: api.archives.supplier,
            },
            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 6,
              url: api.archives.getCategoryTree,
            },
            {
              label: '会员筛选',
              prop: 'memberType',
              type: 'radio',
              span: 6,
              data: [{label: '所有会员', value: 10}, {label: '非会员', value: 20}]
            },
            // {
            //   label: '销量',
            //   prop: 'salesType',
            //   type: 'select',
            //   span: 12,
            //   data: [{label: '全部', value: ""}, {label: '有销量', value: 10}, {label: '无销量', value: 20}]
            // },
            {
              label: '数量',
              prop: 'salesNumber',
              type: 'input',
              inputType:'number',
              span: 6,
            },
            // {
            //   label: "选择日期",
            //   prop: "CreateDttm",
            //   type: "datetimeRange",
            //   dateType: "datetime",
            //   span: 12,
            // },
          ],

        },
        toolConfig: [
          {
            label: "导出",
            code: "export",
            callback: this.exportData,
          },
          {
            label: "趋势分析",
            type: this.$utils.buttonType.tableOperate,
            code: "trendAnalysis",
            callback: this.goodsAnalyse
          },
          {
            label: "记录",
            code: "record",
            type: this.$utils.buttonType.tableOperate,
            callback: this.checkGoods,
          },
        ],
        sales: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'retailPrice', 'payPrice', 'profit'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {label: "商品名称", prop: "goodsName", align: "center", width: "150"},
            {label: "商品条码", prop: "barCode", align: "center", width: '150',},
            {label: "规格", prop: "specs", align: "center", width: "60"},
            {label: "单位", prop: "unitName", align: "center", width: "80"},
            {label: "类别", prop: "goodsCategoryName", align: "center", width: "120"},
            {label: "品牌", prop: "brandName", align: "center", width: "120"},
            {label: "供应商", prop: "supplierName", align: "center", width: "120"},
            {label: "现有库存", prop: "inventoryNum", align: "center", width: "100"},
            {label: "销售数量", prop: "goodsNum", align: "center", width: "100"},
            {label: "商品总售价", prop: "payPrice", align: "center", width: "110"},
          ],
          param: defaultParam,
          // url: api.report.goodsSales,
        },
        readySale: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'retailPrice', 'payPrice', 'profit'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {label: "商品名称", prop: "goodsName", align: "center", width: "150"},
            {label: "商品条码", prop: "barCode", align: "center", width: '150',},
            {label: "规格", prop: "specs", align: "center", width: "60"},
            {label: "单位", prop: "unitName", align: "center", width: "80"},
            {label: "类别", prop: "goodsCategoryName", align: "center", width: "120"},
            {label: "品牌", prop: "brandName", align: "center", width: "120"},
            {label: "供应商", prop: "supplierName", align: "center", width: "120"},
            {label: "现有库存", prop: "inventoryNum", align: "center", width: "100"},
            {label: "销售数量", prop: "goodsNum", align: "center", width: "100"},
            {label: "商品总售价", prop: "payPrice", align: "center", width: "110"},
          ],
          param: defaultParam,
          // url: api.report.goodsSales,
        },
        unmarketable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'retailPrice', 'payPrice', 'profit'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {label: "商品名称", prop: "goodsName", align: "center", width: "150"},
            {label: "商品条码", prop: "barCode", align: "center", width: '150',},
            {label: "规格", prop: "specs", align: "center", width: "60"},
            {label: "单位", prop: "unitName", align: "center", width: "80"},
            {label: "类别", prop: "goodsCategoryName", align: "center", width: "120"},
            {label: "品牌", prop: "brandName", align: "center", width: "120"},
            {label: "供应商", prop: "supplierName", align: "center", width: "120"},
            {label: "现有库存", prop: "inventoryNum", align: "center", width: "100"},
            {label: "销售数量", prop: "goodsNum", align: "center", width: "100"},
            {label: "商品总售价", prop: "payPrice", align: "center", width: "110"},
          ],
          param: defaultParam,
          // url: api.report.goodsUnmarketable,
        },
        //商品销售记录分析--弹框
        listColumns: {
          indexShow: true,//是否显示索引
          columns:
            [
              {
                label: '门店',
                width: '130',
                prop: 'storeName',
                align: "center"
              },
              {
                label: '会员',
                prop: 'memberName',
                width: '100',
                align: "center",
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '130',
                align: "center"
              },
              {
                label: '数量',
                prop: 'goodsNum',
                width: '100',
                align: "center"
              },

              {
                label: '类型',
                prop: 'orderType',
                align: 'center',
                width: '110',
                hidden: false,
                enumData: this.$utils.getCacheStatus('soBillOrder.orderType')
              },
              {
                label: '时间',
                prop: 'createDttm',
                align: 'center',
                width: '130',
                hidden: false
              },
            ],
          url: api.report.goodsSalesRecord,
          param: {goodsId: ""}
        },
      };
    },
    created() {
      // this.allStore()
      this.setStore(this.searchOptions.complex);
      this.getBrandSupplier()
    },
    mounted() {
      if(Object.keys(this.$route.params).length>0){
        if(this.$route.params.code == '5'){
          this.activeTab = 'readySale'
          this.readySale.param = this.$route.params.timeParam
        }
        if(this.$route.params.code == '6'){
          this.activeTab = 'unmarketable'
          this.unmarketable.param = this.$route.params.timeParam
        }
      }
      this.tabChange({name:this.activeTab})
      this.$nextTick(()=>{
        this.$refs[this.activeTab].operationSuccess();
      })
    },
    methods: {
      // 门店身份 登录
      getBrandSupplier(){
        let supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0]
        let goodsBrandId = this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0]
        let userInfo = this.$utils.getSysUser()
        if(userInfo.storeId){
          //通过门店id获取供应商以及仓库
          this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: userInfo.storeId}).then(data => {
            if (data.code === 200) {
              supplierId.data = data.data;
            }
          });
          // 品牌数据
          this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: userInfo.storeId}).then(data => {
            if (data.code === 200) {
              goodsBrandId.data = data.data;
            }
          });
        }
      },
      // 选择门店
      storeChange(form){
        form.goodsBrandId = ''
        form.supplierId = ''
        let supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0]
        let goodsBrandId = this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0]
        //通过门店id获取供应商以及仓库
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            supplierId.data = data.data;
          }
        });
        // 品牌数据
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            goodsBrandId.data = data.data;
          }
        });
      },
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        this.$refs[this.activeTab].clearSearch();
        let userInfo = this.$utils.getSysUser()
        if(!userInfo.storeId){
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
          this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        }
      },
      tabChange(val) {
        // this.$refs['salesStatistical'].closeComplexShow();
        let userInfo = this.$utils.getSysUser()
        if(!userInfo.storeId){
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
          this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        }
        if(val.name === 'readySale'){
          this.readySale.url = api.report.goodsSales
        }else if(val.name === 'unmarketable'){
          this.unmarketable.url = api.report.goodsUnmarketable
        }else{
          this.sales.url = api.report.goodsSales
        }
      },
      memberChecked() {
        let searchParam = {
          pageNumber: this.page.current,
          pageSize: this.page.pageSize
        };
        if (this.checked) {
          this.listColumns.columns.filter(item => item.prop == "orderType")[0].hidden = true
          this.listColumns.columns.filter(item => item.prop == "createDttm")[0].hidden = true
          this.isCombine = true
          this.memberMerge = 10
          let param = Object.assign(searchParam, {goodsId: this.goodsId}, {memberMerge: this.memberMerge});
          this.$axios.fetchPost(api.report.goodsSalesRecord + '/page', param).then(data => {
            if (data.code === 200) {
              this.$refs['goodsCode'].tableData = data.data.records;
              this.$refs['goodsCode'].page.total = data.data.total;
            }
          }).catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
          })
        } else {
          this.listColumns.columns.filter(item => item.prop == "orderType")[0].hidden = false
          this.listColumns.columns.filter(item => item.prop == "createDttm")[0].hidden = false
          this.isCombine = false
          this.$refs["goodsCode"].getTableData()
        }
      },
      // allStore() {
      //   let mes = []
      //   mes.unshift({name: "全部门店", value: ""});
      //   this.$axios.fetchPost(api.system.seStore + '/list').then(data => {
      //     if (data.code === 200) {
      //       data.data.unshift({name: "全部门店", value: ""});
      //       this.searchOptions.simple.filter(item => item.prop === "storeId")[0].data = data.data;
      //     }
      //   })
      // },
      checkGoods(data) {
        this.memberMerge = ""
        this.goodsId = data.goodsId
        let searchParam = {
          pageNumber: this.page.current,
          pageSize: this.page.pageSize
        };
        let param = Object.assign(searchParam, {goodsId: data.goodsId}, {memberMerge: this.memberMerge});
        this.$axios.fetchPost(api.report.goodsSalesRecord + "/page", param).then(data => {
          if (data.code === 200) {
            this.$refs['goodsCode'].tableData = data.data.records;
            this.$refs['goodsCode'].page.total = data.data.total;
          }
        })
        this.listColumns.param.goodsId = data.goodsId
        this.listShow = true;
      },
      //会员统计导出
      salesExport() {
        let url;
        let fileName;
        let exportcode
        let memberMerge
        if (this.isCombine) {
          url = api.report.goodsSalesExport
          fileName = '商品销售会员记录（合并相同会员）.xls';
          exportcode = {exportCode: 'goodsSalesMemberMergeExport'}
          memberMerge = {memberMerge: 10}
          console.log("打开")
        } else {
          url = api.report.goodsSalesExport
          fileName = '商品销售会员记录.xls';
          exportcode = {exportCode: 'goodsSalesMemberExport'}
          memberMerge = {memberMerge: ""}
          console.log("关闭")
        }
        let param = Object.assign(exportcode, {goodsId: this.goodsId}, memberMerge);
        this.$axios.fetchPostBlob(url, param).then(data => {
          const blob = new Blob([data], {type: "application/vnd.ms-excel;charset=utf-8"})
          const elink = document.createElement('a');// 创建a标签
          elink.download = fileName;// 为a标签添加download属性
          // a.download = fileName; //命名下载名称
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();// 点击下载
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);// 释放标签
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        })
      },
      exportData() {
        let params = this.$refs["discountTemplate"].getCurrentParams();
        params.exportCode = 'SoGoodsSalesExport';
        this.$axios.fetchPost(api.report.goodsExport, params).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '导出异常', type: 'error'});
          }
        })
      },
      goodsAnalyse(data) {
        this.goodsName = data.goodsName;
        this.goodsId = data.goodsId;
        let stCreateDttm = this.$refs.discountTemplate.getComplexParams().stCreateDttm;
        console.log(stCreateDttm)
        let Params;
        if (stCreateDttm === undefined) {
          Params = Object.assign({}, {stCreateDttm: this.param.stCreateDttm}, {goodsId: data.goodsId, dateType: 10});
        } else {
          Params = Object.assign({}, {stCreateDttm: stCreateDttm}, {goodsId: data.goodsId, dateType: 10});
        }

        console.log(this.$refs.discountTemplate.getComplexParams().stCreateDttm)
        this.$nextTick(() => {
          //  执行echarts方法
          this.paymentSummary(Params)
        })
        this.analyseShow = true
      },
      paymentSummary(param) {
        this.$axios.fetchPost(api.report.goodsTrendEcharts, param).then((data) => {
          if (data.code == 200) {
            this.goodsSaleTrendEcharts.charsOption.title.text = this.goodsName
            this.goodsSaleTrendEcharts.charsOption.xAxis[0].data = data.data.dateTime;
            this.goodsSaleTrendEcharts.charsOption.series[0].data = data.data.retailPrice;
            this.goodsSaleTrendEcharts.charsOption.series[1].data = data.data.goodsNum;
            this.goodsSaleTrendEcharts.charsOption.series[2].data = data.data.profit;
            this.$nextTick(() => {
              this.$refs.goodsSaleTrendEcharts.drawpic();
            });
          }
        })
          .catch((err) => {
            this.$message({message: "请求失败！", type: "error"});
          });
      },
      getHour() {
        let stCreateDttm = this.$refs.discountTemplate.getComplexParams().stCreateDttm;
        let Params;
        if (stCreateDttm === undefined) {
          Params = Object.assign({}, {stCreateDttm: this.param.stCreateDttm}, {goodsId: this.goodsId, dateType: 10});
        } else {
          Params = Object.assign({}, {stCreateDttm: stCreateDttm}, {goodsId: this.goodsId, dateType: 10});
        }
        this.paymentSummary(Params)
      },
      getDay() {
        let Params = Object.assign({}, this.param, this.$refs.discountTemplate.getComplexParams(), {
          goodsId: this.goodsId,
          dateType: 20
        });
        this.paymentSummary(Params)
      }
    }
  };
</script>

<style scoped>
  .headerButton {
    margin-bottom: 10px;
    padding-left: 20px;
  }

  .charts-trend {
    height: 500px;
    width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/page/report/sales/Statistical.vue